import { render, staticRenderFns } from "./loading-bar.vue?vue&type=template&id=0c0f02a9&scoped=true"
import script from "./loading-bar.vue?vue&type=script&lang=js"
export * from "./loading-bar.vue?vue&type=script&lang=js"
import style0 from "./loading-bar.vue?vue&type=style&index=0&id=0c0f02a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f02a9",
  null
  
)

export default component.exports